export const LOGIN_USER = "LOGIN_USER";
export const INITIALIZE_STORE = "INITIALIZE_STORE";
export const LOGOUT_USER = "LOGOUT_USER";
export const REFRESH_ACCESS_TOKEN = "REFRESH_ACCESS_TOKEN";
export const UPDATE_NOTIFICATIONS = "UPDATE_NOTIFICATIONS";
export const UPDATE_ASSESSMENT_TIME_LEFT = "UPDATE_ASSESSMENT_TIME_LEFT";
export const SET_REDIRECT_URL = "SET_REDIRECT_URL";
export const SET_IS_AUTHENTICATING = "SET_IS_AUTHENTICATING";
